module.exports = __webpack_public_path__ + "static/media/icon_smartphone.41013dcc.png";